import { TaskState } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import TasksModule from '@modules/TasksModule';
import InboxModule from '..';
import ToastModule from '@modules/ToastModule';
import strings from '../constants/strings';
import { CALL_MISSED_TOAST_DURATION } from '../constants/missedCallToastDuration';
import { inboxState } from '../state';
import BrowserNotificationsModule from '@modules/BrowserNotificationsModule';

// contains logic for managing internal call tasks

export function setInternalCallToOffered(
  context: InboxContext,
  sessionId: string,
  from: string,
  displayName: string,
  attributes: Record<string, any>,
) {
  context.logger.info('internal call Offered', sessionId);

  const task = TasksModule.createTask({
    id: sessionId,
    from,
    displayName,
    type: 'voice',
    direction: 'inbound',
    isInternal: true,
    state: TaskState.Offered,
    attributes,
  });
  task.startedAt = new Date();

  ToastModule.showIncomingCallToast({
    id: sessionId,
  });

  // browser notification
  if (document.visibilityState === 'hidden' && task.type === 'voice') {
    BrowserNotificationsModule.showBrowserNotification('ServiceTitan', {
      body: 'You have an incoming call.',
    });
  }
}

export function setInternalCallToAccepted(
  context: InboxContext,
  sessionSid: string,
) {
  context.logger.info('internal call Accepted', sessionSid);
  const task = TasksModule.getTask(sessionSid);
  if (task) {
    ToastModule.hideIncomingCallToast(sessionSid);
    InboxModule.resetMissedCallsInternal();
    TasksModule.setTaskState(sessionSid, TaskState.Accepted);
  }
}

export function setInternalCallToRejected(
  context: InboxContext,
  sessionId: string,
) {
  context.logger.info('internal call Rejected', sessionId);
  const task = TasksModule.getTask(sessionId);
  if (task) {
    ToastModule.hideIncomingCallToast(sessionId);
    TasksModule.setTaskState(sessionId, TaskState.Rejected);
    TasksModule.deleteTask(sessionId);
  }
}

export function setInternalCallToAbandoned(
  context: InboxContext,
  sessionId: string,
) {
  context.logger.info('internal call Abandoned', sessionId);
  const task = TasksModule.getTask(sessionId);

  if (task) {
    ToastModule.hideIncomingCallToast(sessionId);
    InboxModule.handleMissedInternalCall();
    ToastModule.showToast({
      title: strings.labels.toasts.callMissedInternalTitle(
        inboxState.missedCallsInternal,
      ),
      status: 'info',
      duration: CALL_MISSED_TOAST_DURATION,
    });
    TasksModule.setTaskState(sessionId, TaskState.Abandoned);
  }
}

export function setInternalCallToCompleted(
  context: InboxContext,
  sessionId: string,
) {
  context.logger.info('internal call Completed', sessionId);

  TasksModule.setTaskState(sessionId, TaskState.Completed);
  TasksModule.deleteTask(sessionId);
}
